var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("seminar-entry-detail-resume", { attrs: { "entry-id": _vm.entryId } }),
      _vm._v(" "),
      _c("div", { staticClass: "pega-flex-center" }, [
        _c(
          "button",
          {
            staticClass: "boss-button boss-button-fill display-inline-flex",
            attrs: { "data-test": "remove-button" },
            on: { click: _vm.doRemove },
          },
          [_vm._v("この応募者情報を削除する（復活不可）")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }